module.exports = __webpack_public_path__ + "static/media/top-search-active-dark-icon.0c60262a.svg";